/**
 * Minimal className combiner. Filters falsy values and joins with spaces.
 * Pattern from shadcn but without clsx/tailwind-merge — we don't need conflict
 * resolution since Loop's component patterns are append-only.
 */
export function cn(
	...classes: Array<string | false | null | undefined>
): string {
	return classes.filter(Boolean).join(' ')
}
